<template>
    <b-card no-body class="bg-default shadow">
        <b-card-header class="bg-transparent border-0">
            <h3 class="mb-0 text-white">Approval Request Listing in SN-NT (TRTP-2398 - Tengeh Reservoir Tender Project)</h3>

            <div class="text-right">

            </div>
        </b-card-header>

        <el-table class="table-responsive table-dark"
                  header-row-class-name="thead-dark"
                  :data="documents">
            <el-table-column label="Classfication"
                             min-width="130px"
                             prop="name"
                             sortable>
                <template v-slot="{row}">
                    <b-media no-body class="align-items-center">
                        <b-media-body>
                            <span class="font-weight-600 name mb-0 text-sm text-white">{{row.requestClass}}</span>
                        </b-media-body>
                    </b-media>
                </template>
            </el-table-column>

            <el-table-column label="Request By"
                             min-width="90px"
                             prop="name"
                             sortable>
                <template v-slot="{row}">
                    <b-media no-body class="align-items-center">
                        <b-media-body>
                            <span class="font-weight-600 name mb-0 text-sm text-white">{{row.requestBy}}</span>
                        </b-media-body>
                    </b-media>
                </template>
            </el-table-column>

            <el-table-column label="Type"
                             min-width="120px"
                             prop="status"
                             sortable>
                <template v-slot="{row}">
                    <badge class="badge-dot mr-4" type="">

                        <span class="status text-white">{{row.requestType}}</span>
                    </badge>
                </template>
            </el-table-column>

            <el-table-column label="Site"
                             min-width="80px"
                             prop="status"
                             sortable>
                <template v-slot="{row}">
                    <badge class="badge-dot mr-4" type="">

                        <span class="status text-white">{{row.requestSite}}</span>
                    </badge>
                </template>
            </el-table-column>

            <!-- <el-table-column label="Mandatory"
                             min-width="100px"
                             prop="status"
                             sortable>
                <template v-slot="{row}">
                    <badge class="badge-dot mr-4" type="">
                        <i :class="`bg-${row.taskType}`"></i>
                        <span class="status text-white">{{row.taskMandatory}}</span>
                    </badge>
                </template>
            </el-table-column> -->

            <el-table-column label="Request Date"
                             min-width="100px"
                             prop="status"
                             sortable>
                <template v-slot="{row}">
                    <badge class="badge-dot mr-4" type="">

                        <span class="status text-white">{{row.requestDate}}</span>
                    </badge>
                </template>
            </el-table-column>

            <el-table-column label="Action" min-width="170px">
               <template v-slot="{row}">
                    <div class="d-flex align-items-center">
                        <div>
                            <base-button type="primary" size="sm" @click="approvedbutton()">Approved</base-button>
                        </div>
                        &nbsp;
                        <div>
                            <base-button size="sm" type="primary" @click="rejectRequest()">Reject</base-button>
                        </div>
                        &nbsp;
                        <div v-if="row.requestType === 'One Time Document' || row.requestType === 'Recurring Document'">
                          <div>
                              <base-button size="sm" type="primary"><a href="http://www.bournshell.net/customer_bill/customer_log_Jun_2021_15_08_40_110730005.xlsx" class="text-white">Download</a></base-button>
                          </div>
                        </div>
                        <div v-else>
                          <div>
                              <base-button size="sm" type="primary" @click="detailbutton()">View Request</base-button>
                          </div>
                        </div>

                    </div>
                </template>
            </el-table-column>
        </el-table>

        <b-card-footer class="py-2 d-flex justify-content-end bg-transparent">
            <base-pagination v-model="currentPage" :per-page="10" :total="50"></base-pagination>
        </b-card-footer>

        <modal :show.sync="modals.formReject"
                   size="lg"
                   body-classes="p-0">
              <card type="secondary"
                    header-classes="bg-transparent pb-5"
                    body-classes="px-lg-5 py-lg-5"
                    class="border-0 mb-0">
                <template>
                  <div class="text-center text-muted mb-4">
                    <h2>Reject Document to SN-NT - Tengeh Reservoir North Site for (TRTP-2398 - Tengeh Reservoir Tender Project)</h2>
                  </div>
                  <b-form role="form">
                    <base-input label="Classification" name="Classification" placeholder="Classification" v-model="rejectModal.classification" disabled>
                    </base-input>
                    <base-input label="Contractor" name="Contractor" placeholder="Contractor" v-model="rejectModal.contactor" disabled>
                    </base-input>
                    <!-- <base-input label="Contractor" name="Contractor">
                      <select class="form-control" v-model="formModal.contactor">
                        <option value="" disabled>-- Please Select A Contractor --</option>
                        <option value="Solar Ex">Solar Ex</option>
                        <option value="Long Seng">Long Seng</option>
                      </select>
                    </base-input> -->
                    <base-input label="Status" name="Status">
                      <select class="form-control" v-model="rejectModal.status">
                        <option value="" disabled>-- Please Select A Status --</option>
                        <option value="Required Revision">Required Revision</option>
                        <option value="Reject">Reject</option>
                      </select>
                    </base-input>
                    <base-input label="Reject Reason" name="Reject Reason" placeholder="Reject Reason" v-model="rejectModal.reason">
                    </base-input>

                    <!-- <b-form-checkbox v-model="formModal.mandatory"
                    value="Mandatory"
                    unchecked-value="Not_Mandatory">Mandatory</b-form-checkbox> -->
                    <div class="text-center">
                      <base-button type="primary" class="my-4" @click="notifyReject()">Reject Request</base-button>
                      <base-button type="primary" class="my-4" @click="clearModal()">Cancel</base-button>
                    </div>
                  </b-form>
                </template>
              </card>
        </modal>

        <modal :show.sync="modals.formDetails"
                   size="lg"
                   body-classes="p-0">
              <card type="secondary"
                    header-classes="bg-transparent pb-5"
                    body-classes="px-lg-5 py-lg-5"
                    class="border-0 mb-0">
                <template>
                  <div class="text-center text-muted mb-4">
                    <h2>Requesition for Document in SN-NT - Tengeh Reservoir North Site for (TRTP-2398 - Tengeh Reservoir Tender Project)</h2>
                  </div>
                  <b-form role="form">
                    <base-input label="Classification" name="Classification" placeholder="Classification" v-model="formModal.classification" disabled>
                    </base-input>
                    <base-input label="Contractor" name="Contractor" placeholder="Contractor" v-model="formModal.contactor" disabled>
                    </base-input>
                    <base-input label="Reason" name="Request & Reason" placeholder="Request" v-model="formModal.request" disabled>
                    </base-input>
                    <!-- <base-input label="Contractor" name="Contractor">
                      <select class="form-control" v-model="formModal.contactor">
                        <option value="" disabled>-- Please Select A Contractor --</option>
                        <option value="Solar Ex">Solar Ex</option>
                        <option value="Long Seng">Long Seng</option>
                      </select>
                    </base-input>
                    <base-input label="Status" name="Status">
                      <select class="form-control" v-model="formModal.status">
                        <option value="" disabled>-- Please Select A Status --</option>
                        <option value="Pending">Pending</option>
                        <option value="Waiting For Approval">Waiting For Approval</option>
                        <option value="Required Revision">Required Revision</option>
                      </select>
                    </base-input> -->
                     <!-- <h4>Attachment</h4>
                    <dropzone-file-upload v-model="formModal.doc_attachment" multiple></dropzone-file-upload> -->
                    <!-- <b-form-checkbox v-model="formModal.mandatory"
                    value="Mandatory"
                    unchecked-value="Not_Mandatory">Mandatory</b-form-checkbox> -->
                    <div class="text-center">

                      <base-button type="primary" class="my-4" @click="clearModal()">Close</base-button>
                    </div>
                  </b-form>
                </template>
              </card>
        </modal>
    </b-card>

</template>

<script>

  import documents from './js/documents.js'
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
  import {homeLink} from '@/assets/js/config.js'
  import { Modal } from '@/components';
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'

  export default {
    name: 'site-document-table',
    components: {
      Modal,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      DropzoneFileUpload,
    },
    data() {
      return {
        modals: {
          formReject: false,
          formDetails: false,
        },
        formModal: {
          classification: '',
          contactor: '',
          status: '',
          doc_attachment: [],
          title: 'Add New',
          buttonName: 'Add New Document',
          mandatorty : 'Not_Mandatory',
          request: '',
        },
        rejectModal: {
          classification: '',
          contactor: '',
          status: '',
          reason: '',
        },
        documents,
        currentPage: 1,
        img1: homeLink+'/img/theme/team-1.jpg',
      };
    },
    methods: {
       approvedbutton(){
          this.$notify({
          message:
            '<b>Request Approval (Action Item V2.0 - One-Time Document): </b> - Has been Approved.',
          timeout: 10000,
          icon: 'ni ni-bell-55',
          type: 'default',
          });
      },
      detailbutton(){
        this.formModal.contactor = 'Long Seng'
        this.formModal.classification = 'E-Permit To Work'
        this.formModal.request = 'This Site does not require any E-Permit. We already cover that with Blanket Permit.'
        this.modals.formDetails = true
      },
      rejectRequest(){
          this.rejectModal.contactor = 'Solar Ex'
          this.rejectModal.classification = 'Action Item (V2.0)'
          this.rejectModal.status = ''
          this.rejectModal.reason = ''
          // this.formModal.buttonName = 'Update Document'
          // this.formModal.title = 'Edit Document'
          // this.formModal.doc_attachment = []
          // this.formModal.mandatorty = 'Mandatory'
          // this.formModal.request = '',
          this.modals.formReject = true
      },
      notifyVue() {
        if ( this.formModal.request === ''  )
        {
          this.$notify({
          message:
            '<b>Request Input Error : </b> - Please fill Request & Reason.',
          timeout: 10000,
          icon: 'ni ni-bulb-61',
          type: 'danger',
          });
        }
        else
        {
          this.$notify({
          message:
            '<b>New Request : Action Item (' + this.formModal.request + ') : </b> - Successfully Sent to Project Manager. Pending Approval',
          timeout: 10000,
          icon: 'ni ni-bell-55',
          type: 'default',
          });
          this.clearModal()
        }
      },
      notifyReject() {
        if ( this.rejectModal.reason == '')
        {
          this.$notify({
          message:
            '<b>Request Input Error : </b> - Please select A Status & Write the Reason ',
          timeout: 10000,
          icon: 'ni ni-bulb-61',
          type: 'danger',
          });
        }
        else
        {
          this.$notify({
          message:
            '<b>Request Reject (Action Item V2.0 - One-Time Document) : </b> - Succesfully Rejected.',
          timeout: 10000,
          icon: 'ni ni-bell-55',
          type: 'default',
          });
          this.clearModal()
        }
      },
      clearModal()
      {
        this.modals.formReject = false
        this.modals.formDetails = false
        this.formModal.contactor = ''
        this.formModal.classification = ''
        this.formModal.status = ''
        this.formModal.request = '',
        this.formModal.doc_attachment = []

        this.rejectModal.contactor = ''
        this.rejectModal.classification = ''
        this.rejectModal.status = ''
      },
    }
  }
</script>
